import styled, { css } from 'styled-components'

const styles = ({ size }) => css`
  display: inline-block;
  width: ${size ? `${size / 16}rem` : '1em'};
  height: ${size ? `${size / 16}rem` : '1em'};
  box-sizing: border-box;
  margin: ${size ? `${size / 160}rem` : '0.1em'};
`

export const Wrapper = styled.span`
  ${styles};
`
